import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";

import { Button, Confirm } from "semantic-ui-react";

import { ApplicationState } from "../../../../applicationState";

import { ManageAssignedUsersPaths } from "./manageAssignedUsersRoutes";

import { push } from "redux-little-router";

interface Props {
    manageAssignedUsersSubpath: ManageAssignedUsersPaths;
}

export const ManageAssignedUsersButton: React.FunctionComponent<Props> = (props: Props) => {
    const [manageAssignedUsersModalOpen, setManageAssignedUsersModalOpen] = React.useState<boolean>(false);

    const currentPath = useSelector((state: ApplicationState) => state.router.pathname);

    const onManageAssignedUsers = () => setManageAssignedUsersModalOpen(true);

    const onManageAssignedUsersCancel = () => setManageAssignedUsersModalOpen(false);

    const dispatch = useDispatch();
    const onManageAssignedUsersConfirm = () => {
        setManageAssignedUsersModalOpen(false);
        dispatch(push(`${currentPath}/${props.manageAssignedUsersSubpath}`));
    };

    return (
        <>
            <Button onClick={onManageAssignedUsers}>Manage Assigned Users</Button>
            <Confirm
                open={manageAssignedUsersModalOpen}
                // eslint-disable-next-line max-len
                content="By choosing to add more users to this case you will be allowing additional managers or HR Advisors to see the full content and history of this case, including the original referral form and any reports and documents. Please ensure that you have any appropriate permissions or consent required by your employer to share this information before adding more users to the case."
                cancelButton="Cancel"
                confirmButton="Continue"
                onCancel={onManageAssignedUsersCancel}
                onConfirm={onManageAssignedUsersConfirm}
            />
        </>
    );
};
